var path = '/var/www/sldm/resources/assets/app-releases/templates/directives/notes.html';
var html = "<div class=\"container\">\n    <div class=\"content has-text-centered\">\n        <a href=\"https://intersectalliance.com/\" target=\"_blank\" class=\"logo\">\n            <img src=\"/img/snare-logo-full-white.svg\" alt=\"Snare logo\" class=\"\">\n        </a>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/app-releases/templates/directives/notes.html
// module id = 343
// module chunks = 6